import React from 'react';
import clsx from 'clsx';
import styles from './Heading.module.scss';
import { TPolymorphicProps } from '../../../types/utils';

type THeadingProps<T extends React.ElementType> = TPolymorphicProps<T> & {
  size?: 1 | 2 | 3 | 4 | 5 | 6;
};

export const Heading = <T extends React.ElementType = 'h2'>({
  as,
  size = 1,
  children,
  className,
}: THeadingProps<T>) => {
  const Component = as || 'h2';
  const classNames = clsx(
    styles.heading,
    styles[`heading-size-${size}`],
    className
  );

  return <Component className={classNames}>{children}</Component>;
};
